import { Button } from '@edsn/pie-components';
import CsvIcon from '@iconify/icons-material-symbols/csv';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Icon } from '#pie/components/icon/Icon';
import { useDebounce } from '#pie/hooks/useDebounce';
import { usePostContactDetailsExport } from '#pie/internal/api/pie-bff';
import { contactDetailsSortingAtom } from '#pie/stores/contactDetails';
import { paginationAtom } from '#pie/stores/pagination';
import { searchAtom } from '#pie/stores/search';
import { downloadBlob } from '#pie/utils/downloadBlob';
import { useToast } from '../toast/ToastContext';

export const UserManagementExport = () => {
  const { t: tom } = useTranslation('organisationManagement');
  const { addToast } = useToast();
  const pagination = useAtomValue(paginationAtom);
  const sorting = useAtomValue(contactDetailsSortingAtom);
  const search = useAtomValue(searchAtom);
  const debouncedSearch = useDebounce(search, 500);
  const sortCol = sorting[0];

  const { mutate, isPending: isDownloadingCsv } = usePostContactDetailsExport({
    mutation: {
      onSuccess: (data: Blob) => {
        downloadBlob(
          data,
          `Gebruikersbeheer_${format(new Date(), 'yyyy-MM-dd')}.csv`,
        );
      },
      onError: (error) => {
        addToast({
          message: tom('error.export_users.toast.error.message'),
          title: tom('error.export_users.toast.error.title'),
          type: 'error',
          error,
        });
      },
    },
  });

  return (
    <Button
      className="mr-4"
      iconStart={
        <Icon icon={CsvIcon} className="text-action-secondary-enabled" />
      }
      isLoading={isDownloadingCsv}
      action="tertiary"
      emphasis="subtle"
      onClick={() =>
        mutate({
          data: {
            filter: {},
            pagination,
            search: debouncedSearch,
            sorting: sortCol && { descending: sortCol.desc, field: sortCol.id },
          },
        })
      }
    >
      {tom('header.button.export_users')}
    </Button>
  );
};
